export default "__VITE_ASSET__DqQH3g5Z__"